import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "withdraw-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "balance-header flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-title header-5" }, "Opt Balance")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "withdraw-page-body" }
const _hoisted_4 = { class: "withdraw-input" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "info-text" }, "Submitting Withdrawal...", -1 /* HOISTED */)
const _hoisted_6 = { class: "withdraw-input-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "currency" }, "$", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Funds will be sent to the account you linked", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString($props.amount), 1 /* TEXT */)
        ])
      ]),
      _hoisted_8
    ])
  ]))
}